// export const apiUrl ="http://localhost:8000/api/WebApi/";
// export const apiUrl ="http://192.168.43.100:8000/api/WebApi/";
//  export const apiUrl ="http://192.168.100.110:8000/api/WebApi/";
 export const apiUrl ="https://myapi.myamol.ir/api/WebApi/";

